const SERVICES = [
  {
    icon: "ri-home-smile-line",
    title: "Residential Cleaning",
    description:
      "From kitchens to bedrooms, we make your home sparkle. Regular weekly, bi-weekly, or monthly schedules available.",
    features: ["All rooms covered", "Flexible scheduling", "Eco-friendly products"],
    color: "bg-teal-50",
    accent: "text-teal-600",
    img: "https://public.readdy.ai/ai/img_res/0c4730c726fa80a6bd07e88736c897d9.jpg",
  },
  {
    icon: "ri-building-line",
    title: "Commercial Cleaning",
    description:
      "Keep your workspace immaculate and professional. We service offices, retail spaces, and industrial facilities.",
    features: ["After-hours service", "Custom contracts", "Trained crews"],
    color: "bg-amber-50",
    accent: "text-amber-600",
    img: "https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20uniforms%20mopping%20polished%20large%20commercial%20office%20floor%20bright%20fluorescent%20lighting%20open%20plan%20workspace%20clean%20environment%20neat%20minimal%20simple%20neutral%20background&width=600&height=400&seq=service2&orientation=landscape",
  },
  {
    icon: "ri-sparkling-line",
    title: "Deep Cleaning",
    description:
      "A thorough top-to-bottom clean for when standard just isn't enough. Perfect for move-ins, move-outs, or seasonal refresh.",
    features: ["Inside appliances", "Grout & tile scrub", "Baseboards & vents"],
    color: "bg-rose-50",
    accent: "text-rose-600",
    img: "https://readdy.ai/api/search-image?query=deep%20cleaning%20bathroom%20tiles%20professional%20scrubbing%20gleaming%20white%20pristine%20grout%20lines%20bathroom%20sink%20and%20faucet%20polished%20immaculate%20close%20up%20detail%20warm%20bright%20lighting%20simple%20clean%20background&width=600&height=400&seq=service3&orientation=landscape",
  },
  {
    icon: "ri-truck-line",
    title: "Move-In / Move-Out",
    description:
      "Stress-free transitions — leave the cleaning to us. We ensure every corner is spotless before you arrive or after you leave.",
    features: ["Full property clean", "Same-day booking", "Certificate of cleanliness"],
    color: "bg-violet-50",
    accent: "text-violet-600",
    img: "https://readdy.ai/api/search-image?query=empty%20bright%20clean%20apartment%20interior%20fresh%20white%20walls%20polished%20hardwood%20floors%20large%20windows%20natural%20light%20move%20in%20ready%20property%20real%20estate%20minimal%20simple%20clean%20background&width=600&height=400&seq=service4&orientation=landscape",
  },
  {
    icon: "ri-leaf-line",
    title: "Eco-Friendly Cleaning",
    description:
      "Powerful clean using plant-based, non-toxic products. Safe for kids, pets, and the planet.",
    features: ["100% non-toxic", "Biodegradable products", "Green certified"],
    color: "bg-green-50",
    accent: "text-green-600",
    img: "https://readdy.ai/api/search-image?query=eco%20friendly%20cleaning%20products%20green%20plant%20based%20spray%20bottles%20microfiber%20cloths%20wooden%20brush%20bright%20white%20kitchen%20countertop%20sustainable%20natural%20minimal%20clean%20simple%20background&width=600&height=400&seq=service5&orientation=landscape",
  },
];

export default function ServicesOverview() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-teal-600 mb-3 block">
              Our Expertise
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Cleaning Solutions
              <br />
              <span className="text-teal-600">For Every Need</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed max-w-sm">
            Whether it's your home, office, or anything in between — our trained professionals handle it all with care and precision.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              className={`${s.color} rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300`}
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-4 bg-white/70`}>
                  <i className={`${s.icon} ${s.accent} text-xl`} />
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {s.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4">{s.description}</p>
                <ul className="flex flex-col gap-1.5">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                      <i className={`ri-check-line ${s.accent} text-sm`} />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
